

function loadDayData(selection) {
    let app = this;
    for(let i = 0 ; i < app.days.length ; i++ ){

        let weekday = selection.timetables.filter(function(item) {
            return item.weekday ==  app.days[i].id;
        });

        if(weekday.length == 0)
        {

            var end = app.config.defaultEnd[app.location];

            if(app.days[i].id == 'mi')
            {
                var end = app.config.wednesdayEnd[app.location]
            }

            selection.timetables.push(
                {
                    id: this.generateString(12),
                    weekday: app.days[i].id,
                    timestart: app.config.defaultStart[app.location],
                    timeend: end,
                    selection_id: selection.id,
                    disabled: false,
                    timeendmap: null
                }
            );
        }
    }
};

function setSliderData(selection) {
    let app = this;
    for(let i = 0 ; i < selection.timetables.length ; i++ ){

        var time = selection.timetables[i].timeend;
        var value = app.getKeyByValue(app.sliderConfig.marks[app.location],time);
        var slider = app.$refs[ selection.timetables[i].weekday ][0];
        slider.setValue(value);

        let day = app.days.filter(function(item) {
            return item.id == selection.timetables[i].weekday
        });
        selection.timetables[i].name = day[0].name

        if(day[0].disabled){
            selection.timetables[i].disabled = true
        }
        else
        {
            selection.timetables[i].disabled = false
        }
    }
};

function importLunchdata (data,length,dayKey) {

    let app = this;
    let added = [];


    if(length > 1)
    {
        // delete existing lunch services
        app.selections = app.selections.filter(function(item) {
            return item.service_id != app.config.serviceIdLunchs
        });
        // merge data
        app.selections = [].concat(app.selections, data);
    }
    else
    {
        // add new
        for(let i = 0; i < data.length; i++)
        {
            let currentSel = app.lunchSelections.find(element => element.id ==  data[i].id);
            if(currentSel === undefined)
            {
                app.selections.push(data[i]);
                added.push(data[i].id);
            }
        }
        // remove old
        for(let i = app.lunchSelections.length -1; i >= 0; i--)
        {
            if(app.lunchSelections[i].timetables[0].weekday == dayKey)
            {
                let currentDat = data.find(element => element.id ==  app.lunchSelections[i].id);
                if(currentDat === undefined)
                {
                    app.lunchSelections.splice(i,1);
                }
            }
        }

        this.$forceUpdate();
    }

};

function storeData (selections, section_id, next='pdf') {

    let app = this;
    let deleteIds = [];
    let deleteTimetablesIds = app.deletedTimetables;

    // get ids from selections to delete in database
    for(let i = 0; i < app.selectionsOrigin.length; i++)
    {
        if(app.modulRelevantSelections.find(obj => obj.service_id === app.selectionsOrigin[i].service_id))
        {

            let myObj = selections.find(obj => obj.id === app.selectionsOrigin[i].id);
            console.log(myObj);
            if(!myObj &&  typeof app.selectionsOrigin[i].id === 'number' )
            {
                deleteIds.push(app.selectionsOrigin[i].id);
            }
        }else{ // neu  ??? korrekt
            deleteIds.push(app.selectionsOrigin[i].id);
        }
    }


    axios.post('/api/selections/store',{ selections: selections, deleteIds: deleteIds,deleteTimetablesIds: deleteTimetablesIds,section_id : section_id,session: this.session })
        .then(response => {
            if(next=='pdf')
            {
                var nextlink = '/download/' + app.location + '/' + section_id + (app.lang == 'en' ? '/en':'/de');
            }
            if(next=='app')
            {
                var nextlink = '/application/' + (app.location==1 ? 'horgen/1':'kuesnacht/2') + '/' + app.appmode + '/' + section_id +  (app.lang == 'en' ? '/en':'/de');
            }
            if(next=='applunch')
            {
                var nextlink = '/application/' + (app.location==1 ? 'horgen/1':'kuesnacht/2') + '/' + app.appmode + '/' + section_id +  (app.lang == 'en' ? '/en':'/de','?islunch=1');
            }
            window.location.href = nextlink;
            // this.loadData();
            // vorübergehend deaktiviert
        })
        .catch(e => {
            this.errors.push(e)
        });
};


function getSingleSelection(serviceIds) {
    let app = this;
    let selected = this.selections.filter(function(item) {
        return item.location_id == app.location && serviceIds.includes( item.service_id )
    });
    return selected;
};

function createNewSelection(serviceId) {
    let app = this;
    let service = this.services.filter(function(item) {
        return item.id == serviceId;
    });
    let newServ = {
        id: this.generateString(12),
        service: service[0],
        service_id: service[0].id,
        location_id: this.location,
        session_id: app.session,
        timetables: []
    }
    this.selections.push(newServ);
    return newServ;
};

function deleteMultipleSelections() {
    let app = this;
    var found = 0;
    for(let i = 0 ; i < this.selections.length ; i++ ){
        if( this.selections[i].service_id == app.config.serviceIdFull || this.selections[i].service_id == app.config.serviceIdMinus)
        {
            found++;
            if(found > 1)
            {
                this.selections.splice(i, 1);
            }
        }
    }
};



export {  loadDayData, setSliderData , importLunchdata, storeData, getSingleSelection, createNewSelection, deleteMultipleSelections};
